import { useEffect } from "react";

/**
 * Updates document.title and the meta description for a route.
 * Lightweight alternative to react-helmet (no extra deps).
 */
export function usePageMeta({ title, description }) {
  useEffect(() => {
    const previousTitle = document.title;
    const previousDescription = document
      .querySelector('meta[name="description"]')
      ?.getAttribute("content");

    if (title) {
      document.title = title;
    }
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }

    return () => {
      if (title && previousTitle) document.title = previousTitle;
      if (description && previousDescription) {
        document
          .querySelector('meta[name="description"]')
          ?.setAttribute("content", previousDescription);
      }
    };
  }, [title, description]);
}
